<template>
  <b-col :xl="content.columns" cols="12">
    <h4 class="lm-subtitle">{{content.name}}</h4>
  </b-col>
</template>
<script>
export default {
  props: ['content']
}
</script>

<style lang="sass" scoped>
  .lm-subtitle
    margin-bottom: 35px
</style>
